import { type Area } from "react-easy-crop";

/** Same as `aspect` on `Cropper` in `UploadImageInput`. */
const CROP_ASPECT = 2.2;
/** Export width (px) - sharp on retina cards; ~3.5× the old 350px export without huge files. */
const EXPORT_WIDTH = 1280;
const EXPORT_HEIGHT = Math.round(EXPORT_WIDTH / CROP_ASPECT);
const JPEG_QUALITY = 0.9;

export async function cropImage(
  imageSrc: string,
  croppedAreaPixels: Area,
): Promise<File> {
  const img = new Image();
  img.crossOrigin = "anonymous";
  img.src = imageSrc;

  await new Promise((resolve, reject) => {
    img.onload = resolve;
    img.onerror = reject;
  });

  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  if (!ctx)
    throw new Error("Older browser detected - canvas context not supported");

  canvas.width = EXPORT_WIDTH;
  canvas.height = EXPORT_HEIGHT;

  ctx.fillStyle = "white";
  ctx.fillRect(0, 0, EXPORT_WIDTH, EXPORT_HEIGHT);

  ctx.imageSmoothingEnabled = true;
  ctx.imageSmoothingQuality = "high";
  ctx.drawImage(
    img,
    croppedAreaPixels.x,
    croppedAreaPixels.y,
    croppedAreaPixels.width,
    croppedAreaPixels.height,
    0,
    0,
    EXPORT_WIDTH,
    EXPORT_HEIGHT,
  );

  const blob = await new Promise<Blob>((resolve, reject) => {
    canvas.toBlob(
      (b) => {
        if (b) {
          resolve(b);
        } else {
          reject(new Error("Failed to create blob from canvas"));
        }
      },
      "image/jpeg",
      JPEG_QUALITY,
    );
  });

  return new File([blob], "cropped-image.jpg", { type: "image/jpeg" });
}
